import { useTranslation } from "react-i18next";
import { cn } from "@v2/lib/utils";
import { tabItems, tabForView, type View } from "./nav-config";

// Navigazione principale su telefono e tablet.
export function TabBar({ activeView, onSelect, badge = 0 }: { activeView: View; onSelect: (view: View) => void; badge?: number }) {
  const { t } = useTranslation("shell");
  const current = tabForView(activeView);
  return (
    <nav
      aria-label={t("mobileNav.label")}
      className="lg:hidden fixed inset-x-0 bottom-0 z-30 bg-background border-t pb-[env(safe-area-inset-bottom)]"
    >
      <div className="mx-auto max-w-xl grid grid-cols-5">
        {tabItems.map((item) => {
          const Icon = item.icon;
          const active = current === item.id;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onSelect(item.id)}
              aria-current={active ? "page" : undefined}
              className={cn("relative h-16 flex flex-col items-center justify-center gap-1 text-xs transition-colors", active ? "text-foreground font-semibold" : "text-[hsl(var(--faint))]")}
            >
              <Icon className="h-[22px] w-[22px]" strokeWidth={active ? 2.2 : 1.7} />
              {t(item.labelKey)}
              {item.id === "club" && badge > 0 && <span aria-hidden className="absolute top-3 left-1/2 ml-2.5 h-2 w-2 rounded-full bg-[hsl(var(--warn))]" />}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
